import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual, filterArray } from 'helpers/utils'
import { ResultRank } from "components/presentation/ResultRank"
import Competitor from 'components/presentation/Competitor';

export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;
    const data = ((row?.teamAthletes?.length > 0))
        ? row?.teamAthletes
        : undefined
    const dataResults = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined
    return (
        <> <table className="table table-detail">
            <thead>
                <tr>
                    <th style={{ textAlign: "left" }}><Label data="HeaderRaceNo" /></th>
                    <th style={{ textAlign: "left" }}><Label data="HeaderAthlete" /></th>
                    <th></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderSWIM" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderTRANS1" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderBIKE" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderTRANS2" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderRUN" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderTime" /></th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderTotalTime" /></th>
                </tr>
            </thead>
            <tbody>
                {
                    row?.teamAthletes?.sort((a, b) => a.order - b.order).map((athlete, key) => {

                        let resSWIM = findArray(athlete?.extResults, { er_type: ['SWIM'], er_code: ['SECTION'], er_pos: ['F'] })
                        let resT1 = findArray(athlete?.extResults, { er_type: ['TRANS1'], er_code: ['SECTION'], er_pos: ['F'] })
                        let resBIKE = findArray(athlete?.extResults, { er_type: ['BIKE'], er_code: ['SECTION'], er_pos: ['F'] })
                        let resT2 = findArray(athlete?.extResults, { er_type: ['TRANS2'], er_code: ['SECTION'], er_pos: ['F'] })
                        let resRUN = findArray(athlete?.extResults, { er_type: ['RUN'], er_code: ['SECTION'], er_pos: ['F'] })

                        let legTime = findArray(athlete?.extResults, { er_type: ['RUN'], er_code: ['INTERMEDIATE'], er_pos: ['F'] })
                        let legTeamTime = findArray(athlete?.extResults, { er_type: ['RUN'], er_code: ['TEAM_INTERMEDIATE'], er_pos: ['F'] }) // el StartOrder del Athlete falta por sacarlo de la query

                        return (
                            <tr key={'expanded_' + row.participant.code + '_' + key}>
                                <td style={{ textAlign: "left" }}>{row?.bib}/{athlete?.startOrder}</td>
                                <td style={{ textAlign: "left" }}>
                                    <Competitor
                                        name={athlete?.athlete?.name}
                                        shortName={athlete?.athlete?.shortName}
                                        code={athlete?.athlete?.code}
                                        hidePicture={true}
                                        alwaysNoc={false}
                                    />
                                </td>
                                <td style={{ textAlign: "left" }}>{athlete.athlete.personGender.code}</td>
                                <td style={{ textAlign: "right" }}><ResultRank result={resSWIM?.er_value} rank={resSWIM?.er_rank} /></td>
                                <td style={{ textAlign: "right" }}><ResultRank result={resT1?.er_value} rank={resT1?.er_rank} /></td>
                                <td style={{ textAlign: "right" }}><ResultRank result={resBIKE?.er_value} rank={resBIKE?.er_rank} /></td>
                                <td style={{ textAlign: "right" }}><ResultRank result={resT2?.er_value} rank={resT2?.er_rank} /></td>
                                <td style={{ textAlign: "right" }}><ResultRank result={resRUN?.er_value} rank={resRUN?.er_rank} /></td>
                                <td style={{ textAlign: "right" }}>{legTime.er_value}</td>
                                <td style={{ textAlign: "right" }}>{legTeamTime.er_value}</td>
                            </tr>
                        )

                    })

                }




            </tbody>
        </table>

        </>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.resultAnalysis, nextProps.row.resultAnalysis)
    )
});